import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import Page from "../../../../../Components/Dashboard/Page";
import Searchbox from "../../../../../Components/Dashboard/Searchbox";
import { useDispatch, useSelector } from "react-redux";
import {
  components,
  PrintButtonIcon,
} from "../../../../../Components/Icons/DataTableIcons";
import {
  ColumnTextStyle,
  EditIcon,
  MuiDataTableTheme,
  ViewIcon,
} from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import {
  emptyFetchSuccessStoryWithoutPagination,
  fetchSuccessStory,
  fetchSuccessStoryWithoutPagination,
  fetchSuccessStoryById,
  fetchTotalSuccessStory,
  restoreStoryInitial,
} from "../../../../../Actions";
import StatusGenerator from "../../../../../Components/StatusGenerator/StatusGenerator";
import CardAllStories from "../../../../../sections/@dashboard/app/CardAllSuccessStories";
import CardApprovedStories from "../../../../../sections/@dashboard/app/CardApprovedStories";
import { ElevatedGreenButton } from "../../../../../Components/Button/CustomButton";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ArchiveIcon from "@mui/icons-material/Archive";
import { EmptyRowIcon } from "../../../../../Components/Icons/EmptyRowIcon";
import FilterButton from "../../../../../Components/Button/FilterButton";
import { clearMsg } from "../../../../../Utils/apiToasts";
import AddNewStoryDialog from "../../../../../Components/SuccessStory/AddNewSuccessStory";
import CardRejectedStories from "../../../../../sections/@dashboard/app/CardRejectedStories";
import SuccessStoryPrintTemplate from "../../../../../Components/PrintFiles/SuccessStoryPrintTemplate";
const getUsersState = (state) => state.usersReducer;
const getStoryState = (state) => state.successStoryReducer;

LoadingOverlay.propTypes = undefined;

const ManageSuccessStories = () => {
  const {
    successStoryData,
    tablePaginationData,
    isLoading,
    storyUpdated,
    successStoryDataNoPagination,
    storyDetailsbyId,
    storyApproved
  } = useSelector(getStoryState);
  const { authUser } = useSelector(getUsersState);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadPrint, setLoadPrint] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [openNewStoryDialog, setOpenNewStoryDialog] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [storyTableData, setStoryTableData] = useState([]);
  const [singleStoryData, setSingleStoryData] = useState([]);
  const [filters, setFilters] = useState("");
  const [formType, setFormType] = useState("");
  const [isClosedDialog, setIsClosedDialog] = useState(false);
  const [resetState, setResetState] = useState(false);
  const [filterOptions, setFilterOptions] = useState("");
  const [loadingState, setLoadingState] = useState(false);

  useEffect(() => {
    if (Object.keys(storyDetailsbyId).length !== 0) {
      setSingleStoryData(storyDetailsbyId);
    }
  }, [storyDetailsbyId]);

  const handleOpen = () => {
    setOpenNewStoryDialog(true);
    setFormType("add");
    setIsClosedDialog(true);
    setResetState(false);
  };

  const handleOpenViewStoryDialog = (id) => {
    console.log(id, "Single Story data");
    dispatch(fetchSuccessStoryById(id));
    setOpenNewStoryDialog(true);
    setFormType("view");
  };

  const handleOpenEditStoryDialog = (id) => {
    if (!id) {
      setFormType("edit");
    } else {
      dispatch(fetchSuccessStoryById(id));
      setOpenNewStoryDialog(true);
      setFormType("edit");
    }
  };

  const handleClose = () => {
    setOpenNewStoryDialog(false);
    setIsClosedDialog(false);
    setResetState(true);
  };

  const handleSearch = (e) => {
    let searchValue = e.target.value;
    setSearch(searchValue);
  };

  const handleFilterClick = (event) => {
    if (event !== 0) {
      setLoadingState(true);
      setFilterOptions(event);
    }
  };

  const handleReset = (event) => {
    if (filterOptions !== "") {
      setLoadingState(true);
      setFilterOptions("");
      setFilters("");
    }
  };

  useEffect(() => {
    let params = {};
    params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      Search: search,
    };

    if (
      filterOptions.states !== "" &&
      filterOptions.states !== 0 &&
      filterOptions.states !== undefined
    ) {
      params["FilterOptions.State"] = filterOptions.states;
    } else {
      delete params["FilterOptions.State"];
    }

    dispatch(fetchSuccessStory(params));
    dispatch(fetchTotalSuccessStory());
    return () => {
      dispatch(restoreStoryInitial());
    };
  }, [dispatch, pageNumber, pageSize, search, filterOptions]);

  useEffect(() => {
    if (storyUpdated === true || storyApproved === true) {
      let params = {};
      params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: search,
      };

      if (
        filterOptions.states !== "" &&
        filterOptions.states !== 0 &&
        filterOptions.states !== undefined
      ) {
        params["FilterOptions.State"] = filterOptions.states;
      } else {
        delete params["FilterOptions.State"];
      }
      dispatch(fetchSuccessStory(params));
      dispatch(fetchTotalSuccessStory());
      handleClose();
      return () => {
        dispatch(restoreStoryInitial());
      };
    }
  }, [storyUpdated, storyApproved]);

  useEffect(() => {
    if (successStoryData && successStoryData.length !== 0) {
      console.log("data", successStoryData);
      setLoadingState(false);
      const createStoryData = () => {
        let storyTableData = [];
        successStoryData.map((val) => {
          let row = [
            val?.cmName,
            val?.cmStateCode,
            val?.skill?.name,
            val?.businessName,
            val?.phoneNumber,
            val?.trainingCenterName,
            val?.approvalStatus,
            val,
          ];
          return storyTableData.push(row);
        });
        setStoryTableData(storyTableData);
      };
      Object.keys(successStoryData).length > 0 && createStoryData();
    } else {
      setStoryTableData([]);
      setShowNoDataMessage(true);
      setLoadingState(false);
    }
  }, [successStoryData]);

  const columns = [
    {
      name: "corpsmembers",
      label: "Corps Members",
      options: {
        sort: true,
        setCellProps: () => ({ style: { minWidth: "200px", padding: "20px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              <span style={{ marginLeft: "20px" }}>{column.label}</span>
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "cmStatecode",
      label: "State Code",
      options: {
        setCellProps: () => ({ style: { minWidth: "130px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "skillacquired",
      label: "Skill Acquired",
      options: {
        setCellProps: () => ({ style: { minWidth: "130px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "businessname",
      label: "Business Name",
      options: {
        setCellProps: () => ({ style: { minWidth: "200px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "phonenumber",
      label: "Phone Number",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "trainingcenter",
      label: "Training Center",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        sort: false,
        setCellProps: () => ({ style: { minWidth: "200px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          switch (value) {
            case 0:
              return (
                <StatusGenerator
                  statusText="Submitted"
                  variant="yellowFilled"
                />
              );
            case 1:
              return (
                <StatusGenerator
                  statusText="State Officer Approved"
                  variant="greenOutlined"
                />
              );
            case 2:
              return (
                <StatusGenerator
                  statusText="State Officer Disapproved"
                  variant="redOutlined"
                />
              );
            case 3:
              return (
                <StatusGenerator
                  statusText="State Co-ord. Approved"
                  variant="greenOutlined"
                />
              );
            case 4:
              return (
                <StatusGenerator
                  statusText="State Co-ord. Disapproved"
                  variant="redOutlined"
                />
              );
            case 5:
              return (
                <StatusGenerator
                  statusText="HQ Approved"
                  variant="greenFilled"
                />
              );
            case 6:
              return (
                <StatusGenerator
                  statusText="HQ Disapproved"
                  variant="redFilled"
                />
              );
            default:
              return "no status";
          }
        },
        filter: true,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: "80px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          // console.log(tableMeta)
          return (
            <>
              <Tooltip title={"View Success Story"}>
                <IconButton
                  size="small"
                  onClick={() => handleOpenViewStoryDialog(value.id)}
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>
              {authUser?.role !== "SAED_NDHQ" &&
                authUser?.role !== "SAED_State_Coordinator" &&
                authUser?.role !== "SAED_State" &&
                value.approvalStatus === 0 && (
                  <Tooltip title={"Edit Story"}>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenEditStoryDialog(value.id)}
                    >
                      <EditIcon icon="icon-park-outline:edit" />
                    </IconButton>
                  </Tooltip>
                )}
            </>
          );
        },
      },
    },
  ];

  const CustomToolbarSelect = () => {
    const handleClickArchive = () => {
      // this.props.setSelectedRows([]);
    };
    return (
      <div style={{ marginRight: " 24px" }}>
        <Tooltip title={"Archive Story"}>
          <IconButton onClick={handleClickArchive}>
            <ArchiveIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  const changePage = (page) => {
    setLoading(true);
    setPageNumber(page);
  };

  const fireApi = () => {
    return dispatch(fetchSuccessStoryWithoutPagination());
  };
  const printSuccessStoryPdf = async () => {
    await fireApi();
    setLoadPrint(true);
    setShowPrintPreview(true);
  };

  const printIdCardArea = () => {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.srcdoc = document.getElementById("printarea").innerHTML;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
    clearMsg();
  };

  useEffect(() => {
    if (successStoryDataNoPagination.length > 0 && showPrintPreview === true) {
      console.log(successStoryDataNoPagination, "now")
      printIdCardArea();
      setShowPrintPreview(false);
      setLoadPrint(false);
    }
  }, [successStoryDataNoPagination, showPrintPreview]);

  useEffect(() => {
    if (!showPrintPreview) {
      dispatch(emptyFetchSuccessStoryWithoutPagination());
    }
  }, [showPrintPreview, dispatch]);

  const options = [
    {
      type: "autocomplete",
      name: "states",
      group: "Select States",
      options: [],
    },
  ];

  const paginationOptions = {
    filter: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    search: false,
    print: false,
    serverSide: true,
    count: tablePaginationData?.totalCount,
    page: pageNumber - 1,
    jumpToPage: true,
    responsive: "standard",
    disableRipple: true,
    elevation: 0,
    filterType: "dropdown",
    fixedHeader: true,
    tableBodyMinHeight: "600px",
    tableBodyMaxHeight: "1000px",
    selectableRows: "none",
    checkbox: false,

    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
      />
    ),
    textLabels: {
      body: {
        noMatch: showNoDataMessage ? <EmptyRowIcon /> : "",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Download sheet",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
    customToolbar: () => {
      return (
        <>
          <Tooltip title="Print Table">
            <IconButton onClick={printSuccessStoryPdf}>
              {loadPrint ? <CircularProgress size={24} /> : <PrintButtonIcon />}
            </IconButton>
          </Tooltip>
          {authUser?.role === "SAED_NDHQ" && (
            <FilterButton
              options={options}
              filters={filters}
              onClick={handleFilterClick}
              reset={handleReset}
            />
          )}
          {authUser?.role !== "SAED_NDHQ" &&
            // authUser?.role !== "SAED_State" &&
            authUser?.role !== "SAED_State_Coordinator" &&
            authUser?.role === "SAED_LGI" && (
              <ElevatedGreenButton
                onClick={handleOpen}
                startIcon={<AddOutlinedIcon />}
              >
                Add Success Story
              </ElevatedGreenButton>
            )}
        </>
      );
    },
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setLoading(true);
        changePage(tableState.page + 1);
        return () => {
          setLoading(false);
        };
      }
    },
  };

  return (
    <Page title="SAED | Manage Success Stories">
      <Container maxWidth="xl">
        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#212B36" }}
          >
            Manage Success Stories
          </Typography>
        </Box>
        <Box sx={{ pb: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md>
              <CardAllStories />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardApprovedStories />
            </Grid>
            <Grid item xs={12} sm={6} md>
              {/* <CardRejectedStories /> */}
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Paper
                sx={{
                  boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                  borderRadius: "20px",
                }}
              >
                <Card
                  elevation={0}
                  sx={{ padding: "0px !important", borderRadius: "20px" }}
                >
                  <CardContent sx={{ padding: "0px !important" }}>
                    <ThemeProvider theme={MuiDataTableTheme}>
                      <LoadingOverlay
                        active={loadingState || isLoading}
                        styles={{
                          overlay: (base) => ({
                            ...base,
                            background: "rgba(0, 0, 0, 0.15)",
                          }),
                        }}
                        spinner
                        text="Fetching Data for You..."
                      >
                        <MUIDataTable
                          title={
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={10}
                              justifyContent="space-between"
                            >
                              <Typography
                                sx={{ color: "#05004E", fontWeight: 600 }}
                              >
                                Success Stories
                              </Typography>
                              <Searchbox
                                size={"300px"}
                                placeholder="Stories"
                                onChange={handleSearch}
                                value={search}
                              />
                            </Box>
                          }
                          data={storyTableData}
                          columns={columns}
                          options={paginationOptions}
                          components={components}
                          style={{ transition: "0.7s" }}
                        />
                      </LoadingOverlay>
                    </ThemeProvider>
                  </CardContent>
                </Card>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <div id="printarea" style={{ display: "none" }}>
        <SuccessStoryPrintTemplate />
      </div>
      <AddNewStoryDialog
        singleStoryData={singleStoryData}
        openNewStoryDialog={openNewStoryDialog}
        handleClose={handleClose}
        formType={formType}
        handleOpenEditStoryDialog={handleOpenEditStoryDialog}
        isClosedDialog={isClosedDialog}
        resetState={resetState}
      />
    </Page>
  );
};

export default ManageSuccessStories;
